// Audit list of every token the admin has deployed. Reads from backend.

import React, { useEffect, useState } from 'react';
import { addressUrl, txUrl } from '../config/chains';
import api from '../services/api';
import './ContractList.css';

function ContractList() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api.get('/contracts').then(
      (res) => { if (!cancelled) { setRows(res.data?.data || []); setLoading(false); } },
      (err) => { if (!cancelled) { setError(err.message); setLoading(false); } },
    );
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="contract-list">
      <h2>Deployed contracts</h2>

      {loading && <div>Loading…</div>}
      {error && <div className="cl-err">Failed to load: {error}</div>}

      {!loading && rows.length === 0 && (
        <div className="cl-empty">No contracts deployed yet. <a href="/deploy">Deploy one</a>.</div>
      )}

      {rows.length > 0 && (
        <table className="cl-table">
          <thead>
            <tr>
              <th>Name</th><th>Symbol</th><th>Address</th><th>Tx</th><th>Deployer</th><th>When</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id || r.contractAddress}>
                <td>{r.tokenName}</td>
                <td>{r.tokenSymbol}</td>
                <td>
                  <a href={addressUrl('bsc', r.contractAddress)} target="_blank" rel="noreferrer">
                    {r.contractAddress?.slice(0, 8)}…{r.contractAddress?.slice(-6)}
                  </a>
                </td>
                <td>
                  {r.transactionHash ? (
                    <a href={txUrl('bsc', r.transactionHash)} target="_blank" rel="noreferrer">view</a>
                  ) : '—'}
                </td>
                <td>{r.deployerAddress?.slice(0, 8)}…{r.deployerAddress?.slice(-4)}</td>
                <td>{r.createdAt ? new Date(r.createdAt).toLocaleString() : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ContractList;
